import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import {Card, CardHeader, CardText } from 'material-ui/Card';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetGroupComponent';

var styles = AppSettings.styles;

class WidgetGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: true
        };

        this.setViewGroup = this.setViewGroup.bind(this);

    }
    
    getChildContext() {
        return {
            setViewGroup: this.setViewGroup
        };
    }

    setViewGroup(state){
        this.setState({
            view: state
        });

    }
    render() {
        if(!this.state.view){
            return null;
        }
   
        let _iconClass = ['fa-mg', 'mg-user-icon'];
        if(this.props.icon != ""){
            _iconClass.push(this.props.icon);
        }
        else{
            _iconClass.push('fa-mg-betting-2');
        }

        let _className = ["mg-box-widget"];
        if(this.props.className != ""){
            _className.push(this.props.className);
        }

        let mgId = this.props.id;
        return (
            <div id={mgId} className="mg-user-widget">
                <Card containerStyle={styles.mgCardStyle} className={_className.join(" ")}>
                    <CardHeader 
                                titleStyle={styles.mgCardTitle} 
                                subtitleStyle={styles.mgCardSubTitle}
                                title={this.props.title}
                                subtitle={this.props.subtitle}
                                actAsExpander={true}
                                showExpandableButton={true}
                                avatar={<i className={_iconClass.join(" ")}></i>}
                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.props.children}
                    </CardText>
                </Card>
            </div>
           
        );
    }
}

WidgetGroup.displayName = componentName;

// PropTypes validation
WidgetGroup.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    id: PropTypes.string
};

// default props
WidgetGroup.defaultProps = {
    subtitle: "Giocate, MemoBet",
    id: ""
};

WidgetGroup.childContextTypes = {
    setViewGroup: PropTypes.func
}

export default WidgetGroup;